import { render } from "./AcceptAsEmployee.vue?vue&type=template&id=d0d95bc2"
import script from "./AcceptAsEmployee.vue?vue&type=script&lang=js"
export * from "./AcceptAsEmployee.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__